<template>
  <v-container>
    <v-card>
      <v-container class="pb-0 pt-2 mobile-container">
        <v-card-actions class="pb-0">
          <span class="text-h5 pl-1">Importación de farmacias</span>
          <v-spacer></v-spacer>
          <v-tooltip text="Cerrar" location="left">
            <template v-slot:activator="{ props }">
              <v-btn
                color="primary"
                v-bind="props"
                class="to-right"
                :icon="closeIcon"
                id="v-btn-close-importar-farmacia"
                @click="closeModal"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </v-card-actions>
        <v-card-text class="px-0">
          <v-row>
            <v-col cols="12" class="px-2">
              <v-file-input
                ref="file"
                v-model="file"
                :disabled="loading"
                :loading="loading"
                id="file-input-excel-farmacia"
                type="file"
                dense
                variant="underlined"
                label="Excel"
                placeholder="Seleccionar el archivo Excel"
                accept=".xls,.xlsx,.csv"
                outlined
                @change="importExcel"
                @click:clear="clearExcelFile"
                prepend-icon="mdi-paperclip"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-3 pr-0">
          <v-btn
            color="success"
            variant="text"
            @click="openFormatoModal"
            id="v-btn-ver-formato-farmacia"
          >
            Ver formato
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="!enableProcess || !file"
            :loading="loadingBtn"
            @click="saveFileData"
            id="v-btn-importar-farmacia"
          >
            Importar
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-dialog
      v-if="openModalElegirFarmaciasRepetidas"
      v-model="openModalElegirFarmaciasRepetidas"
      :max-width="isMobile ? '95%' : '95%'"
      persistent
    >
      <v-card>
        <v-container>
          <v-card-actions class="pb-0 pt-2">
            <span class="text-h5">Farmacias repetidas</span>
            <v-spacer></v-spacer>
            <v-tooltip text="Cerrar" location="left">
              <template v-slot:activator="{ props }">
                <v-btn
                  color="primary"
                  v-bind="props"
                  class="to-right"
                  :icon="closeIcon"
                  id="v-btn-close-modal-farmacias-repetidas"
                  @click="cerrarModalRepetidos"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-card-actions>
          <v-card-text class="px-0">
            <v-data-table
              :headers="farmaciasRepetidasHeaders"
              :hide-default-header="isMobile"
              :items="farmaciasRepetidas"
              outlined
              :loading="dataTableIsLoading"
            >
              <template v-slot:[`item.selectFarmacia`]="{ item }">
                <div v-if="item && item.farmaciasCoincidentes.length > 0">
                  <v-autocomplete
                    v-model="item.farmaciaId"
                    :items="farmaciasDisponiblesParaItem(item)"
                    item-title="farmaciaNombre"
                    item-value="farmaciaId"
                    :disabled="item.farmaciasCoincidentes.length === 0"
                    variant="underlined"
                    dense
                    hide-details
                    id="v-select-farmacia-repetida"
                    :menu-props="{ closeOnContentClick: true }"
                    label="Seleccionar farmacia"
                  >
                    <template v-slot:item="{ item, props }">
                      <v-list-item v-bind="props">
                        <v-list-item-subtitle
                          v-if="item.raw.farmaciaId != null"
                        >
                          Razon social:
                          {{
                            item.raw.farmaciaRazonSocial
                          }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          v-if="item.raw.farmaciaId != null"
                        >
                          Teléfono:
                          {{
                            item.raw.farmaciasXfinanciadores[0]
                              ?.farmaciaTelefono
                          }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          v-if="item.raw.farmaciaId != null"
                        >
                          Dirección:
                          {{
                            item.raw.farmaciasXfinanciadores[0]
                              ?.farmaciaDireccion
                          }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="pb-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              variant="flat"
              :disabled="!enableProcess || !file"
              :loading="loadingBtn"
              @click="saveRegistrosRepetidos"
              id="v-btn-importar-farmacia"
            >
              Importar
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="openModalFormatoImportacion"
      v-model="openModalFormatoImportacion"
      :max-width="isMobile ? '95%' : '65%'"
      persistent
    >
      <VerFormatoImportaciones
        tipoEntidad="Farmacias"
        @closeDialog="closeFormatoModal"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import helpersExcel from "@/utils/helpers/importExportExcel.js";
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums";
import VerFormatoImportaciones from "@/components/shared/VerFormatoImportaciones.vue";

export default {
  name: "ImportacionFarmacia",
  components: {
    VerFormatoImportaciones,
  },
  props: {
    financiadorId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
    farmaciasSeleccionadas() {
      return this.farmaciasRepetidas
        .map((f) => f.farmaciaId)
        .filter((id) => id != null);
    },
  },
  data() {
    return {
      loading: false,
      file: null,
      excelData: [],
      fileName: "",
      fileDataTranslated: [],
      dataTableIsLoading: false,
      openModalElegirFarmaciasRepetidas: false,
      openModalFormatoImportacion: false,
      farmaciasRepetidas: [],
      farmaciasRepetidasHeaders: [
        { title: "Nombre", value: "nombre" },
        { title: "CUIT", value: "cuit" },
        { title: "Teléfono", value: "telefono" },
        { title: "Domicilio", value: "domicilio" },
        { title: "Provincia", value: "provincia" },
        { title: "Farmacia existente", value: "selectFarmacia" },
      ],
      loadingBtn: false,
      enableProcess: false,
      expectedHeaders: [
        "Nombre",
        "Razon social",
        "CUIT",
        "Telefono",
        "Domicilio",
        "Email",
        "Provincia",
        "Observacion",
        "Codigo",
        "Deshabilitado",
      ],
      errores: [],
      closeIcon: enums.icons.CLOSE_ICON,
    };
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      saveImportacionFarmaciaRepetidas:
        "farmacia/saveImportacionFarmaciaRepetidas",
      saveImportacionFarmacia: "farmacia/saveImportacionFarmacia",
    }),
    clearExcelFile() {
      this.fileDataTranslated = [];
      this.excelData = [];
    },
    async importExcel() {
      try {
        this.loading = true;
        this.excelData = [];
        this.fileDataTranslated = [];
        
        // Capturar el nombre del archivo
        this.fileName = this.file ? this.file.name : "";
        
        await this.getArchivo();

        if (!this.hasValidData()) {
          this.setAlert({
            type: "warning",
            message: "Archivo inválido. ",
          });
          return;
        }

        const validHeaders = helpersExcel.validarCabecerasExcel(
          this.file,
          this.expectedHeaders
        );
        if (!validHeaders) {
          this.resetFileInput();
          return;
        }
        this.excelData[0].filas.forEach((x) => {
          this.fileDataTranslated.push({
            nombre: x["NOMBRE"]?.toString()?.trim() ?? "",
            razonSocial: x["RAZON SOCIAL"]?.toString()?.trim() ?? "",
            cuit: x["CUIT"]?.toString().trim() ?? "",
            telefono: x["TELEFONO"]?.toString().trim() ?? "",
            domicilio: x["DOMICILIO"]?.toString().trim() ?? "",
            email:
              typeof x["EMAIL"] == "object"
                ? x["EMAIL"].text?.toString().trim()
                : x["EMAIL"]?.toString().trim() ?? "",
            provincia: x["PROVINCIA"]?.toString().trim() ?? "",
            observacion: x["OBSERVACION"]?.toString().trim() ?? "",
            codigo: x["CODIGO"]?.toString().trim() ?? "",
            deshabilitado:
              x["DESHABILITADO"]?.toString().trim().toUpperCase() == "SI"
                ? true
                : false ?? "",
          });
        });

        this.enableProcess = true;
      } catch (error) {
        console.error("Error al importar el archivo:", error);
        this.resetFileInput();
      } finally {
        this.loading = false;
      }
    },
    async saveRegistrosRepetidos() {
      this.fileDataTranslated = [];
      const fileDataRepetidos = this.farmaciasRepetidas.map((x) => {
        return {
          nombre: x.nombre,
          razonSocial: x.razonSocial,
          cuit: x.cuit,
          cuitUsuario: x.cuitUsuario,
          telefono: x.telefono,
          domicilio: x.domicilio,
          provincia: x.provincia,
          codigo: x.codigo,
          observacion: x.observacion,
          email: x.email,
          provId: x.provId,
          deshabilitado: x.deshabilitado,
          farmaciaId: x.farmaciaId, // Asignar el ID de la farmacia seleccionada
        };
      });
      this.loadingBtn = true;
      const data = {
        financiadorId: this.financiadorId,
        fileData: fileDataRepetidos,
      };
      try {
        const response = await this.saveImportacionFarmaciaRepetidas(data);
        if (response.status == 200) {
          this.loadingBtn = false;
          if (response.data) {
            this.setAlert({
              type: "success",
              message: "Farmacias importadas con éxito. ",
            });
          } else {
            this.closeModal();
            this.reloadFarmacias();
            this.setAlert({
              type: "warning",
              message: "Ocurrió un error al importar. ",
            });
          }
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al importar farmacias: ${error}`,
        });
        this.resetFileInput();
      }
      this.closeModal();
      this.reloadFarmacias();
    },
    farmaciasDisponiblesParaItem(item) {
      //aca filtramos para que no se elija dos veces la misma farmacia
      return item.farmaciasCoincidentes.filter(
        (f) =>
          f.farmaciaId === item.farmaciaId || // dejar la seleccionada actual
          (!this.farmaciasSeleccionadas.includes(f.farmaciaId) && // no elegir dos veces la misma farmacia
            !f.farmaciasXfinanciadores?.some(
              (x) => x.financiadorId === this.financiadorId
            )) // no mostrar farmacias que ya pertenecen al financiador
      );
    },
    async saveFileData() {
      this.loadingBtn = true;
      const data = {
        financiadorId: this.financiadorId,
        fileData: this.fileDataTranslated,
        nombreArchivo: this.fileName,
      };
      try {
        const response = await this.saveImportacionFarmacia(data);
        if (response.status == 200) {
          this.loadingBtn = false;

          // 1. Si hay repetidos, abrir el modal y setear farmaciasRepetidas
          if (response.data.validarRepetidos?.length > 0) {
            this.openModalElegirFarmaciasRepetidas = true;
            this.farmaciasRepetidas = response.data.validarRepetidos.map(
              (x) => {
                x.farmaciasCoincidentes.push({
                  farmaciaNombre: "Nueva farmacia",
                  farmaciaId: null,
                });
                return x;
              }
            );
          }

          // 2. Si hay errores, exportarlos y mostrar alerta
          if (response.data.fileData.length > 0) {
            this.errores = response.data.fileData;
            this.setAlert({
              type: "warning",
              message: "Existen datos con errores. ",
            });
            this.exportErrors();
            // Si hubo errores y NO se abrió el modal de repetidos, cerrar modal y recargar farmacias
            if (!this.openModalElegirFarmaciasRepetidas) {
              this.closeModal();
              this.reloadFarmacias();
            }
          }

          // 3. Si NO hay repetidos y NO hay errores, éxito total
          if (
            (!response.data.validarRepetidos ||
              response.data.validarRepetidos.length === 0) &&
            (!response.data.fileData || response.data.fileData.length === 0)
          ) {
            this.setAlert({
              type: "success",
              message: "Datos importados con éxito. ",
            });
            this.closeModal();
            this.reloadFarmacias();
          }
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al importar farmacias: ${error}`,
        });
        this.resetFileInput();
      }
    },
    exportErrors() {
      let result = [];
      this.errores.forEach((x) => {
        result.push({
          ["Nombre"]: x.nombre ?? "",
          ["Razon social"]: x.razonSocial ?? "",
          ["CUIT"]: x.cuit ?? "",
          ["Telefono"]: x.telefono ?? "",
          ["Domicilio"]: x.domicilio ?? "",
          ["Provincia"]: x.provincia ?? "",
          ["Codigo"]: x.codigo ?? "",
          ["Email"]: x.email ?? "",
          ["Deshabilitado"]: x.deshabilitado ? "SI" : "NO",
          ["Errores"]: x.errores,
        });
      });

      let formato = {
        filas: result,
        hoja: "Errores importación",
      };
      helpersExcel.excelExport(formato, "Errores importación farmacias");
    },
    hasValidData() {
      return (this.excelData == undefined || !!this.excelData?.[0]?.filas?.length);    
    },
    async getArchivo() {
      this.$refs["file"].validate(true);

      if (this.$refs.file.validate())
        this.excelData = await helpersExcel.excelImport(this.file, 0);
      else throw new Error("Archivo inválido");
    },
    resetFileInput() {
      this.$refs["file"].reset();
      this.file = null;
      this.fileName = "";
      this.fileDataTranslated = this.excelData = [];
      this.enableProcess = this.loading = false;
      return;
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    reloadFarmacias() {
      this.$emit("reloadFarmacias");
    },
    cerrarModalRepetidos() {
      this.openModalElegirFarmaciasRepetidas = false;
      this.farmaciasRepetidas = [];
      this.closeModal();
      this.reloadFarmacias();
    },
    openFormatoModal() {
      this.openModalFormatoImportacion = true;
    },
    closeFormatoModal() {
      this.openModalFormatoImportacion = false;
    },
  },
};
</script>